import { render, staticRenderFns } from "./Reguster.vue?vue&type=template&id=0c7277ac&scoped=true"
import script from "./Reguster.vue?vue&type=script&lang=js"
export * from "./Reguster.vue?vue&type=script&lang=js"
import style0 from "./Reguster.vue?vue&type=style&index=0&id=0c7277ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7277ac",
  null
  
)

export default component.exports